import * as Yup from 'yup';

const CreateNewPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, 'Must be longer than 8 characters')
    .max(16, 'Must be less than 16 characters')
    .required('This field is required'),
  confirmPassword: Yup.string()
    .min(8, 'Must be longer than 8 characters')
    .max(16, 'Must be less than 16 characters')
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('This field is required'),
});

export default CreateNewPasswordSchema;
